import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/sharp-regular-svg-icons';
import { FunctionComponent, memo } from 'react';
import { isDesktop } from 'react-device-detect';

import AppDownloadButton from '@/components/button/appDownloadButton/appDownloadButton';
import Typography from '@/components/typography';
import { useNavigationContext } from '@/features/navigation/provider';

const DownloadAppCTA: FunctionComponent = () => {
  const { downloadAppCTAIsOpen, setDownloadAppCTAIsOpen } =
    useNavigationContext();

  if (!downloadAppCTAIsOpen || isDesktop) return null;

  return (
    <div className="relative z-[161] flex w-full items-center gap-5 bg-gray-90 px-4 py-2 text-white">
      <Typography className="mr-auto" variant="h5">
        Try the mobile app!
      </Typography>
      <AppDownloadButton />
      <button type="button" onClick={() => setDownloadAppCTAIsOpen(false)}>
        <FontAwesomeIcon icon={faXmark} size="xl" />
      </button>
    </div>
  );
};

export default memo(DownloadAppCTA);
